import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

interface ColumnaNota {
  E45COD: string;
  E45DES: string;
  E45TIP: string;
  E45SUS: string;
  EDITABLE: string;
}

interface CeldaNota {
  E47NOT: number | string;
  E47SUS: string;
  M38COD: string;
  E45COD: string;
}

interface EstudianteFila {
  M12CAR: string;
  M12NOM: string;
  M07COD: string;
  ESTMAT: string;
  M38COD: string;
  Notas: { [E45COD: string]: CeldaNota };
}

interface OpcionEstado { M38COD: string; M38DES: string; }
interface OpcionTipoActa { value: string; label: string; show: string; }
interface ReporteDisponible { SYS10COD: string; SYS10DES: string; SYS21ICO: string; }
interface JustificacionPendiente { M12CAR: string; M12NOM: string; E47NOT: number; E47JUS: string; }

@Component({
  selector: 'app-serviciodocente-notas',
  templateUrl: './notas.html',
  styleUrls: ['./notas.scss']
})
export class NotasComponent implements OnInit {

  @Input() WsLlaves: any;
  @Output() cancelar = new EventEmitter<void>();

  private urlCargar       = 'api/ws/sap/Notas/CargarMatriz/regNotas';
  private urlGrabar       = 'api/ws/sap/Notas/GrabarCelda/regNotas';
  private urlCambiarEst   = 'api/ws/sap/Notas/CambiarEstado/regNotas';
  private urlJustifPend   = 'api/ws/sap/Notas/JustificacionesPendientes/regNotas';
  private urlFormalizar   = 'api/ws/sap/Notas/Formalizar/regNotas';
  private urlReporte      = 'api/mantenimientos/VerReporte/';

  M05COD = '';
  M18COD = '';
  M19COD = '';
  M11COD = '';
  M23GRU = '';

  header: any = {};
  tiposActa: OpcionTipoActa[] = [];
  tipoActaActual = '';
  columnas: ColumnaNota[] = [];
  estudiantes: EstudianteFila[] = [];
  estudiantesAux: EstudianteFila[] = [];
  estadosCatalogo: { [M07COD: string]: OpcionEstado[] } = {};
  reportes: ReporteDisponible[] = [];
  permisos: any = { GRABAR: 'N', FORMALIZAR: 'N' };

  formalizarSeleccionado = '';
  buscaCarne = '';
  cargando = false;

  justificaciones: JustificacionPendiente[] = [];
  tipoFormalizarPendiente = '';
  filaActiva = -1;

  private notaAnterior: { [k: string]: number | string } = {};
  private estadoAnterior: { [k: string]: string } = {};

  @ViewChild('modalJustificaciones') modalJustifTpl: TemplateRef<any>;
  private modalRef: NgbModalRef;

  constructor(private dataService: SharedService, private modalService: NgbModal) { }

  ngOnInit(): void {
    console.log('[NotasComponent] ngOnInit, llaves recibidas:', this.WsLlaves);

/*
    const llavesRow = this.extraerLlaves(this.llaves);
    console.log('[NotasComponent] llavesRow extraidas:', llavesRow);
    this.M05COD = llavesRow.M05COD || localStorage.getItem('M05COD') || '';
    this.M18COD = llavesRow.M18COD || localStorage.getItem('M18COD') || '';
    this.M19COD = llavesRow.M19COD || localStorage.getItem('M19COD') || '';
    this.M11COD = llavesRow.M11COD || localStorage.getItem('M11COD') || '';
    this.M23GRU = llavesRow.M23GRU || localStorage.getItem('M23GRU') || '';
*/

    let objetoJSON = {
      LLAVES: this.WsLlaves
    };
    this.cargarMatriz('');
  }


  cargarMatriz(tipo: string) {
    let objetoJSON = {
      LLAVES: this.WsLlaves
    };

    this.cargando = true;

    this.dataService.ConsultarWS(this.urlCargar, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        const d = resp.DATA || {};
        this.header = d.Header || {};
        this.tipoActaActual = d.TipoActaActual || '';
        this.tiposActa = d.TiposActa || [];
        this.columnas = d.Columnas || [];
        this.estudiantes = d.Estudiantes || [];
        this.estudiantesAux = JSON.parse(JSON.stringify(this.estudiantes));
        this.estadosCatalogo = d.EstadosCatalogo || {};
        this.reportes = d.Reportes || [];
        this.permisos = d.Permisos || { GRABAR: 'N', FORMALIZAR: 'N' };
        this.cargando = false;
      },
      (err: any) => {
        this.cargando = false;
        Swal.fire('Error', err || 'No fue posible cargar la matriz de notas', 'error');
      });
  }

  cambiarTipoActa(value: string) {
    if (!value) return;
    this.tipoActaActual = value;
    this.cargarMatriz(value);
  }

  estadosDe(estudiante: EstudianteFila): OpcionEstado[] {
    return this.estadosCatalogo[estudiante.M07COD] || [];
  }

  notaDe(estudiante: EstudianteFila, col: ColumnaNota): string {
    const celda = estudiante.Notas[col.E45COD];
    if (!celda || celda.E47NOT === null || celda.E47NOT === undefined) return '';
    const n = Number(celda.E47NOT);
    if (col.EDITABLE === 'N') return isNaN(n) ? '' : n.toFixed(2);
    return celda.E47NOT.toString();
  }

  guardarValorAnterior(estudiante: EstudianteFila, col: ColumnaNota, target: HTMLInputElement) {
    this.notaAnterior[`${estudiante.M12CAR}_${col.E45COD}`] = target.value;
  }

  marcarFila(idx: number) {
    this.filaActiva = idx;
  }

  grabarNota(estudiante: EstudianteFila, col: ColumnaNota, target: HTMLInputElement) {
    const valor = target.value.replace(',', '.');
    const key = `${estudiante.M12CAR}_${col.E45COD}`;
    const anterior = this.notaAnterior[key];
    if (valor === anterior) return;

    if (valor === '') {
      this.persistirNota(estudiante, col, '', target);
      return;
    }
    const n = Number(valor);
    if (isNaN(n)) {
      Swal.fire('Error', 'Número incorrecto', 'error');
      target.value = anterior != null ? anterior.toString() : '';
      return;
    }
    if (this.tipoActaActual === 'EXTRAORDINARIA') {
      if (n < 1 || n > 7) {
        Swal.fire('Error', 'Nota inválida. El rango permitido en acta extraordinaria es de UNO a SIETE.', 'error');
        target.value = anterior != null ? anterior.toString() : '';
        return;
      }
    } else {
      if (n < 0 || n > 100) {
        Swal.fire('Error', 'Nota inválida. El rango permitido es de CERO a CIEN.', 'error');
        target.value = anterior != null ? anterior.toString() : '';
        return;
      }
    }
    this.persistirNota(estudiante, col, valor, target);
  }

  private persistirNota(estudiante: EstudianteFila, col: ColumnaNota, valor: string, target: HTMLInputElement) {
    let llaves = this.WsLlaves;
    llaves[0].M12CAR = estudiante.M12CAR;
    llaves[0].E47NOT = valor;
    llaves[0].E45COD = col.E45COD;
    let objetoJSON = {
      LLAVES: llaves
    };
    this.dataService.ConsultarWS(this.urlGrabar, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        const d = resp.DATA || {};
        if (!estudiante.Notas[col.E45COD]) {
          estudiante.Notas[col.E45COD] = { E47NOT: valor, E47SUS: 'N', M38COD: '' ,E45COD: col.E45COD};
        } else {
          estudiante.Notas[col.E45COD].E47NOT = valor;
        }
        this.actualizarPromedios(estudiante, d);
      },
      (err: any) => {
        target.value = (this.notaAnterior[`${estudiante.M12CAR}_${col.E45COD}`] || '').toString();
        Swal.fire('Error', err || 'No fue posible grabar la nota', 'error');
      });
  }

  private actualizarPromedios(estudiante: EstudianteFila, data: any) {
    for (const col of this.columnas) {
      if (col.EDITABLE === 'S') continue;
      const valor = this.valorPromedio(col, data);
      if (valor != null) {
        if (!estudiante.Notas[col.E45COD]) {
          estudiante.Notas[col.E45COD] = { E47NOT: valor, E47SUS: 'N', M38COD: '' ,E45COD: col.E45COD};
        } else {
          estudiante.Notas[col.E45COD].E47NOT = valor;
        }
      }
    }
    if (data.M38COD) estudiante.M38COD = data.M38COD;
  }

  private valorPromedio(col: ColumnaNota, data: any): number | null {
    if (col.E45DES === 'P.F.' && data.PROMEDIO_FINAL != null)         return data.PROMEDIO_FINAL;
    if (col.E45DES === 'P.E.' && data.PROMEDIO_EXTRAORDINARIO != null) return data.PROMEDIO_EXTRAORDINARIO;
    if ((col.E45DES === 'P.C.' || col.E45DES === 'P.S.') && data.PROMEDIO_CAMBIOS != null) return data.PROMEDIO_CAMBIOS;
    if (col.E45DES === 'N.P.' && data.PROMEDIO_FINAL != null)         return data.PROMEDIO_FINAL;
    return null;
  }

  guardarEstadoAnterior(estudiante: EstudianteFila, target: HTMLSelectElement) {
    this.estadoAnterior[estudiante.M12CAR] = target.value;
  }

  cambiarEstado(estudiante: EstudianteFila,target: HTMLSelectElement) {

    const nuevoM38 = target.value;
    if (!nuevoM38) {
      Swal.fire('Atención', 'Debe indicar un estado válido', 'warning');
      target.value = this.estadoAnterior[estudiante.M12CAR] || '';
      return;
    }

    let llaves = this.WsLlaves;
    llaves[0].M12CAR = estudiante.M12CAR;
    llaves[0].M38COD = nuevoM38;
    let objetoJSON = {
      LLAVES: llaves
    };

    const colFinal = this.columnas.find(c => c.E45DES === 'P.F.' || c.E45DES === 'N.P.');
    if (!colFinal) return;

    this.dataService.ConsultarWS(this.urlCambiarEst, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        estudiante.M38COD = nuevoM38;
        const m38npr = resp?.DATA?.M38NPR;
        if (m38npr) {
          const colNP = this.columnas.find(c => c.E45DES === 'N.P.');
          if (colNP) {
            if (!estudiante.Notas[colNP.E45COD]) {
              estudiante.Notas[colNP.E45COD] = { E47NOT: m38npr, E47SUS: 'N', M38COD: '',E45COD: colNP.E45COD};
            } else {
              estudiante.Notas[colNP.E45COD].E47NOT = m38npr;
            }
          }
        }
      },
      (err: any) => {
        target.value = this.estadoAnterior[estudiante.M12CAR] || '';
        Swal.fire('Error', err || 'No fue posible cambiar el estado', 'error');
      });
  }

  buscarCarne(event: any) {
    if (event.keyCode !== 13) return;
    const q = (event.target.value || '').toString();
    if (!q) {
      this.estudiantes = JSON.parse(JSON.stringify(this.estudiantesAux));
      return;
    }
    this.estudiantes = this.estudiantesAux.filter(
      e => e.M12CAR.includes(q) || (e.M12NOM || '').toLowerCase().includes(q.toLowerCase())
    );
  }

  imprimirReporte(rep: ReporteDisponible) {
    let objetoJSON = {
      LLAVES: this.WsLlaves
    };
    this.dataService.ConsultarWS(this.urlReporte, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        const base64 = resp?.DATA;
        if (!base64) {
          Swal.fire('Atención', 'El reporte no devolvió contenido', 'warning');
          return;
        }
        const link = document.createElement('a');
        link.href = 'data:application/pdf;base64,' + base64;
        link.target = '_blank';
        link.click();
      },
      (err: any) => Swal.fire('Error', err || 'No fue posible generar el reporte', 'error'));
  }

  formalizar(tipo: string) {
    if (!tipo) return;
    const exigeJustif = tipo === 'CAMBIOS' || tipo === 'EXTRAORDINARIA';
    if (exigeJustif) {
      this.tipoFormalizarPendiente = tipo;
      this.consultarJustificaciones();
      return;
    }
    Swal.fire({
      title: 'Confirma',
      text: 'Está seguro que desea formalizar los promedios ' + tipo + '?',
      icon: 'question',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) this.invocarFormalizar(tipo, []);
      else this.formalizarSeleccionado = '';
    });
  }

  private consultarJustificaciones() {
    let objetoJSON = {
      LLAVES: this.WsLlaves
    };
    this.dataService.ConsultarWS(this.urlJustifPend, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        this.justificaciones = (resp?.DATA || []).map((j: any) => ({
          M12CAR: j.M12CAR, M12NOM: j.M12NOM, E47NOT: j.E47NOT, E47JUS: j.E47JUS || ''
        }));
        if (this.justificaciones.length === 0) {
          this.invocarFormalizar(this.tipoFormalizarPendiente, []);
          return;
        }
        this.modalRef = this.modalService.open(this.modalJustifTpl, { size: 'lg', backdrop: 'static' });
      },
      (err: any) => {
        this.formalizarSeleccionado = '';
        Swal.fire('Error', err || 'No fue posible consultar las justificaciones', 'error');
      });
  }

  confirmarJustificaciones() {
    const sinJus = this.justificaciones.find(j => !j.E47JUS || !j.E47JUS.trim());
    if (sinJus) {
      Swal.fire('Atención', 'Debe diligenciar observaciones en todas las notas modificadas', 'warning');
      return;
    }
    this.invocarFormalizar(this.tipoFormalizarPendiente, this.justificaciones);
    if (this.modalRef) this.modalRef.close();
  }

  cancelarJustificaciones() {
    if (this.modalRef) this.modalRef.dismiss();
    this.formalizarSeleccionado = '';
  }

  private invocarFormalizar(tipo: string, justifs: JustificacionPendiente[]) {
    let objetoJSON = {
      LLAVES: this.WsLlaves
    };
    const body: any = {
      LLAVES: [{
        M05COD: this.M05COD, M18COD: this.M18COD, M19COD: this.M19COD,
        M11COD: this.M11COD, M23GRU: this.M23GRU,
        TIPO: tipo
      }]
    };
    if (justifs.length) {
      body.LLAVES[0].JUSTIFICACIONES = justifs.map(j => ({ M12CAR: j.M12CAR, E47JUS: j.E47JUS }));
    }
    this.dataService.ConsultarWS(this.urlFormalizar, JSON.stringify(objetoJSON)).subscribe(
      (resp: any) => {
        Swal.fire('Realizado', resp?.DATA || 'Formalización exitosa', 'success');
        this.formalizarSeleccionado = '';
        this.cargarMatriz(this.tipoActaActual);
      },
      (err: any) => {
        this.formalizarSeleccionado = '';
        Swal.fire({ title: 'Error', icon: 'error', html: '<div style="white-space:pre-line">' + (err || '') + '</div>' });
      });
  }

  emitirCancelar() {
    this.cancelar.emit();
  }
}
